import httpService from '~/utils/http';

// 获取侧边栏数据 参数：path_name=mapSdk&level=10
export const getSidebarDataApi = async (param) => await httpService({
  url: '/api/site/demopage/category/listByPathName',
  data: param
});

// 获取示例内容 参数：parent_id=010503&article_id=37
export const getSdkDemoContent = async (param) => await httpService({
  url: '/api/site/sdkdemo/content',
  data: param
});


// 获取示例列表 参数：parent_id=010503
export const getDemoIdApi = async (param) => await httpService({
  url: '/api/site/sdkdemo/list',
  data: param
});

// 获取目录名称 参数：path_name=mapSdk
export const getCategoryInfoApi = async (param) => await httpService({
  url: '/api/site/demopage/category/infoByPathName',
  data: param
});

